export default __webpack_public_path__ + "static/media/crypto-experts.69ed5779.png";